import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const FloatingCTA = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShow(window.scrollY > 800);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!show) return null;

    return (
        <div className="fixed bottom-8 right-8 z-40">
            <Link
                to="/contact"
                className="bg-[#A2CB52] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#B5D575] transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:scale-105 flex items-center space-x-2 animate-pulse"
            >
                <span>🎁 Get FREE Assessment</span>
                <ArrowRight size={20} />
            </Link>
        </div>
    );
};

export default FloatingCTA;
